import React, { useState } from "react";
import {
  ChoiceGroup,
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType,
  Dropdown,
  PrimaryButton,
  TextField,
  mergeStyleSets,
  getTheme,
  ResponsiveMode,
} from "@fluentui/react";
import snippetType from "../constants/snippetTypeConstants";

const getClassNames = (theme) =>
  mergeStyleSets({
    input: {
      marginBottom: theme.spacing.m,
    },
    footer: {
      marginTop: theme.spacing[12],
    },
    cancelBtn: {
      color: theme.palette.themePrimary,
      border: `2px solid ${theme.palette.themePrimary}`,
    },
    saveBtn: {
      background: theme.palette.themePrimaryLight,
      border: `1px solid ${theme.palette.themePrimaryLight}`,
      color: theme.palette.white,
    },
  });

const advisorOption = { key: snippetType.ADVISOR.key, text: snippetType.ADVISOR.label };

const accountOption = { key: snippetType.ACCOUNT.key, text: snippetType.ACCOUNT.label };

const globalOption = { key: snippetType.GLOBAL.key, text: snippetType.GLOBAL.label };

const snippetTypeOptions = (canManageGlobal, hasAccountAccess) => {
  if (canManageGlobal && hasAccountAccess) {
    return [advisorOption, accountOption, globalOption];
  } else if (canManageGlobal && !hasAccountAccess) {
    return [advisorOption, globalOption];
  } else if (!canManageGlobal && hasAccountAccess) {
    return [advisorOption, accountOption];
  } else {
    return [advisorOption];
  }
};

const dialogContentProps = {
  type: DialogType.normal,
  title: "New Snippet",
};

const SaveSnippetDialog = ({ open, handleOpen, onSave, caseTypes, canManageGlobal, hasAccountAccess }) => {
  const [description, setDescription] = useState("");
  const [type, setType] = useState();
  const [caseType, setCaseType] = useState();
  let theme = getTheme();
  let { footer, input, cancelBtn, saveBtn } = getClassNames(theme);

  const handleSave = (e) => {
    e.preventDefault();

    switch (type) {
      case snippetType.GLOBAL.key:
        onSave(caseType?.key, null, false, description);
        break;
      case snippetType.ADVISOR.key:
        onSave(caseType?.key, null, true, description);
        break;
      case snippetType.ACCOUNT.key:
        onSave(caseType?.key, true, false, description);
        break;

      default:
        break;
    }
    handleOpen(false);
    setDescription(null);
    setType(null);
    setCaseType(null);
  };

  return (
    <Dialog hidden={!open} onDismiss={() => handleOpen(false)} dialogContentProps={dialogContentProps}>
      <form onSubmit={handleSave} autocomplete="off">
        <TextField
          required
          label="Name"
          onChange={(e) => setDescription(e.target.value)}
          className={input}
          autoComplete="new-password"
        />
        <Dropdown
          label="Case Type"
          required
          selectedKey={caseType ? caseType.key : 0}
          onChange={(e, type) => setCaseType(type)}
          options={caseTypes}
          className={input}
          responsiveMode={ResponsiveMode.large}
        />
        <ChoiceGroup
          required
          options={snippetTypeOptions(canManageGlobal, hasAccountAccess)}
          label="Snippet Type"
          selectedKey={type}
          onChange={(e, option) => setType(option.key)}
          className={input}
        />
        <DialogFooter className={footer}>
          <DefaultButton className={cancelBtn} onClick={() => handleOpen(false)} text="Cancel" />
          <PrimaryButton className={saveBtn} type="submit" text="Save" />
        </DialogFooter>
      </form>
    </Dialog>
  );
};

export default SaveSnippetDialog;
